/**
 * The mark and the wordmark, side by side, linking home. It uses only the sprite's ids, never its paths, so
 * the client nav that imports it never carries the traced wordmark (wordmark.ts, drawn by Sprite.tsx).
 */
export function FamilyLogo({ href }: { href: string }) {
  return (
    <a className="logo" href={href} aria-label="Vestra home">
      <svg aria-hidden="true">
        <use href="#vf-mark" />
      </svg>
      <svg className="wm" viewBox="0 0 3808 1132" aria-hidden="true">
        <use href="#vf-wordmark" />
      </svg>
    </a>
  );
}
